import React from "react";
import Header from "../../Frontend/Shared/Header/Header";
import Sidebar from "../../Frontend/Shared/Sidebar";
import Footer from "../../Frontend/Shared/Footer/Footer";
import MumbaiRouting from "./MumbaiRouting";

const MumbaiLayout = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <Header benchId={benchId} benchName={benchName} benchCode={benchCode} />
      <div className="main-center-area">
        <div className="container-fluid">
          <div className="row">
            <Sidebar benchId={7} calendarId={benchId} />
            <MumbaiRouting benchId={benchId} benchName={benchName} />
          </div>
        </div>
      </div>
      <Footer benchId={benchId} />
    </>
  );
};

export default MumbaiLayout;
